/**
 *
 * This file includes styles for the GaqInputField, ValidationFeedback
 * and the Validation Icon
 *
 */

import styled, { css } from "styled-components";

export const RIGHT_ICON_OFFSET = "var(--dui-size-space-20x)";

export const inputFieldBorderStyles = css`
  border: solid var(--dui-size-width-border-xs)
    ${({ isInvalid, isValid }) => {
      if (isInvalid) {
        return "var(--dui-color-red-500) !important";
      }
      if (isValid) {
        return "var(--dui-color-positive-700)";
      }
      return "var(--dui-color-gray-500)";
    }};
  border-radius: var(--dui-size-radius-md);
  box-sizing: border-box;
  transition: border-color var(--dui-duration-3x);
`;

export const StyledIconWrapper = styled.div`
  --dhl-validation-feedback-icon-size: calc(var(--dui-size-theme) * 1.313rem);
  --dhl-validation-feedback-icon-size-half: calc(
    var(--dhl-validation-feedback-icon-size) / 2
  );

  @keyframes appearFromSide {
    from {
      transform: translateX(20px) rotateZ(0.5turn);
      opacity: 0;
    }

    to {
      transform: translateY(0) rotateZ(0);
      opacity: 1;
    }
  }

  display: block;
  height: var(--dhl-validation-feedback-icon-size);
  width: var(--dhl-validation-feedback-icon-size);
  position: absolute;
  top: calc(50% - var(--dhl-validation-feedback-icon-size-half));
  animation: appearFromSide var(--dui-duration-3x);
  ${({ position }) => css`
    ${
      position === "left" ? "left" : "right"
    }: var(--dui-size-space-5x) !important;
    margin-${
      position === "left" ? "left" : "right"
    }: var(--dui-size-space-2x) !important;
  `}

  & svg {
    height: var(--dui-size-space-full) !important;
    width: var(--dui-size-space-full) !important;
    color: ${({ variant }) => {
      switch (variant) {
        case "error":
          return "var(--dui-color-red-400)";
        case "success":
          return "var(--dui-colors-icons-positive)";
        default:
          return "var(--dui-color-gray-500)";
      }
    }};
  }
`;

export const ValidationMessageContainer = styled.div`
  ${({ hasValidationMsg }) => css`
    display: ${hasValidationMsg ? "block" : "none"};
    margin-top: ${hasValidationMsg ? "var(--dui-size-space-4x)" : 0};
  `}
`;

export const disabledStyles = {
  container: css`
    background-color: var(--dui-color-gray-50);
    cursor: not-allowed;
  `,
  items: css`
    color: var(--dui-color-gray-400);
  `,
};
